import React, { useContext } from 'react';
import { GlobalSiteDataContext } from '../../../../context';
import { UnlimitedPackage } from '../../../specials';

export default function ULPackageBuilder() {
    const siteData = useContext(GlobalSiteDataContext);

    return <UnlimitedPackage siteData={siteData} />;
}
